export const ErrorPage = () => {
    return (
        <div>
            <h1>An error occured, please contact Gard Support.</h1>
        </div>
    );
};
